import { IModel } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';

import { BaseSchemaGeneratorTransformation } from './base-schema-generator-transformation';

@Metamodel.model({
    name: 'guard',
    display: ['guard', 'guards'],
    referable: true,
    constraints: {
        name: {
            required: true
        },
        method: {
            required: true
        }
    }
})
export class GuardTransformation extends BaseSchemaGeneratorTransformation {
    public static readonly MODEL: IModel;

    protected getGeneratedDescription(): string {
        return stringResources.ExecuteFlowletTransformationDescription;
    }
}
